import { useState, useEffect } from 'react';
import { useHistory, Link, useParams } from 'react-router-dom';
import Api from '../api/api';
import arrayUtilities from '../../utilities/arrayUtilities';
import roleUtilities from '../../utilities/roleUtilities';
import { isDateTimeElapsed, isToDateAfterFromDate, toInputFieldDateString, toDateString, minutesToUnit } from '../../utilities/dateUtilities';
import Loader from '../shared/loader';
import stringHelpers from '../../utilities/stringHelpers';
import { ClientSiteTabbed } from './clientSiteTabbed';
import { ErrorModal } from '../../utilities/errorModal';
import { AllowListDateTimeForm } from './formDateTimeDetails';
import { DisplayDateTime } from './displayDateTime';
import Enums from '../../utilities/enum';

function AllowedVrm(props) {
    const userOrganisation = props.user.organisations.find(x => x.organisation.id === props.organisationId);

    const isClientOrClientManager = roleUtilities.isClientOrClientManager(props.user, props.organisationId);    
    const clientAssignedSiteIds = userOrganisation?.siteIds;
    const clientAssignedSiteGroupIds = userOrganisation?.siteGroupIds;
    const { allowedVrmId } = useParams()
    const [allowedVrm, setAllowedVrm] = useState(null);

    const [isNew, setIsNew] = useState(false);
    const [isInEdit, setIsInEdit] = useState(false);
    const [canSave, setCanSave] = useState(false);

    const [allowListUrl, setAllowListUrl] = useState("");

    const [vrm, setVrm] = useState("");
    const [vehicleMake, setVehicleMake] = useState("");
    const [vehicleModel, setVehicleModel] = useState("");
    const [siteName, setSiteName] = useState("");
    const [colour, setColour] = useState("");
    const [reference, setReference] = useState("");
    const [clients, setClients] = useState(null);
    const [formClientId, setFormClientId] = useState("");
    const [driverName, setDriverName] = useState("");
    const [driverMobileNumber, setDriverMobileNumber] = useState("");
    const [driverEmailAddress, setDriverEmailAddress] = useState("");
    const [blueBadgeNumber, setBlueBadgeNumber] = useState("");
    const [blueBadgeExpiryDate, setBlueBadgeExpiryDate] = useState("");
    const [startDate, setStartDate] = useState(props.areDatesRequired ? new Date().toISOString() : "");
    const [endDate, setEndDate] = useState("");
    const [validOnlyOnSpecificDays, setValidOnlyOnSpecificDays] = useState(false)
    const [isValidMonday, setIsValidMonday] = useState(false)
    const [isValidTuesday, setIsValidTuesday] = useState(false)
    const [isValidWednesday, setIsValidWednesday] = useState(false)
    const [isValidThursday, setIsValidThursday] = useState(false)
    const [isValidFriday, setIsValidFriday] = useState(false)
    const [isValidSaturday, setIsValidSaturday] = useState(false)
    const [isValidSunday, setIsValidSunday] = useState(false)
    const [enabledFromTime, setEnabledFromTime] = useState("00:00:00")
    const [enabledToTime, setEnabledToTime] = useState("23:59:00")
    const [validOnlyAtSpecificTimes, setValidOnlyAtSpecificTimes] = useState(false)
    const [reason, setReason] = useState("");
    const [maxStayMinutes, setMaxStayMinutes] = useState(null);
    const [noReturnWithinMinutes, setNoReturnWithinMinutes] = useState(null);

    const [site, setSite] = useState("");
    const [sites, setSites] = useState("");
    const [siteGroups, setSiteGroups] = useState(null);
    const [siteGroup, setSiteGroup] = useState("");

    const [anprCameras, setAnprCameras] = useState(null);
    const [anprCameraId, setAnprCameraId] = useState(null);
    const [roi, setRoi] = useState(null);
    const [tabActiveKey, setTabActiveKey] = useState(isClientOrClientManager && !arrayUtilities.isNullOrEmpty(clientAssignedSiteIds) ? "site" : "global");
    const [loadingVehicleLookup, setLoadingVehicleLookup] = useState(false)
    const [errorMessage, setErrorMessage] = useState("");
    const [successfulLookupVrm, setSuccessfulLookupVrm] = useState(null)
    const history = useHistory();

    const getAllowedVrm = function () {
        Api.getAllowedVrm(
            (data) => {
                setAllowedVrm(data);
            },
            (error) => console.log(error),
            props.organisationId,
            allowedVrmId,
            props.token
        );
    };
    const getClients = () => {
        Api.getClients(
            data => setClients(data),
            error => console.log(error),
            props.organisationId,
            props.token
        )
    }
    const getSites = function (callback) {
         Api.getSites(
                (data) => {
                    setSites(data);
                    if (callback) {
                        callback();
                    }
                },
                (error) => console.log(error),
                props.organisationId,
                props.token
            )
    };

    const vehicleLookup = () => {
        setLoadingVehicleLookup(true)
        Api.vehicleLookup(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    setVehicleMake(data.vehicleMake)
                    setVehicleModel(data.vehicleModel)
                    setColour(data.vehicleColour)
                    setSuccessfulLookupVrm(vrm)
                    setErrorMessage(null)
                }
                setLoadingVehicleLookup(false)
            },
            () => {
                setErrorMessage("Unable to locate vehicle details. Please check the VRM and try again.")
                setLoadingVehicleLookup(false)
            },
            vrm,
            props.organisationId, props.token
        )
    }

    const submit = function () {
        if (canSave) {
            var submitSiteId;

            if (site !== null) {
                submitSiteId = site.id;
            } else {
                submitSiteId = null;
            }
            Api.addAllowedVrm(
                (data) => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage);
                    } else {
                        setAllowedVrm(data);
                        setErrorMessage("");
                        setIsNew(false);
                        history.push("allowed-vrm/" + data.id);
                    }
                },
                (error) => {
                    setErrorMessage(error.errorMessage)
                },
                vrm,
                vehicleMake,
                vehicleModel,
                colour,
                reference,
                driverName,
                driverMobileNumber,
                stringHelpers.isNullOrEmpty(startDate) ? null: new Date(startDate).toISOString(),
                stringHelpers.isNullOrEmpty(endDate) ? null : new Date(endDate).toISOString(),
                validOnlyAtSpecificTimes ? enabledFromTime + ':00' : null,
                validOnlyAtSpecificTimes ? enabledToTime + ':00' : null,
                isValidMonday,
                isValidTuesday,
                isValidWednesday,
                isValidThursday,
                isValidFriday,
                isValidSaturday,
                isValidSunday,
                reason,
                submitSiteId,
                !stringHelpers.isNullOrEmpty(formClientId) ? formClientId : null,
                anprCameraId,
                roi,
                !stringHelpers.isNullOrEmpty(siteGroup) ? siteGroup : null,
                !stringHelpers.isNullOrEmpty(blueBadgeNumber) ? blueBadgeNumber : null,
                !stringHelpers.isNullOrEmpty(blueBadgeExpiryDate) ? blueBadgeExpiryDate : null,
                maxStayMinutes,
                noReturnWithinMinutes,
                props.organisationId,
                props.token
            );
        }
    };

    const edit = function () {
        if (canSave) {
            var editSiteId;
            if (site !== null && site !== undefined) {
                editSiteId = site.id;
            }
            else {
                editSiteId = null;
            }
            Api.editAllowedVrm(
                data => {
                    if (data.isError) {
                        setErrorMessage(data.errorMessage);
                    } else {
                        setIsInEdit(false);
                        getAllowedVrm();
                        setErrorMessage("");
                    }
                },
                (error) => {
                    console.log(error.errorMessage)
                    setErrorMessage(error.errorMessage)
                },
                vrm,
                vehicleMake,
                vehicleModel,
                colour,
                reference,
                driverName,
                driverMobileNumber,
                stringHelpers.isNullOrEmpty(startDate) ? null: new Date(startDate).toISOString(),
                stringHelpers.isNullOrEmpty(endDate) ? null : new Date(endDate).toISOString(),
                validOnlyAtSpecificTimes ? enabledFromTime + ':00' : null,
                validOnlyAtSpecificTimes ? enabledToTime + ':00' : null,
                isValidMonday,
                isValidTuesday,
                isValidWednesday,
                isValidThursday,
                isValidFriday,
                isValidSaturday,
                isValidSunday,
                reason,
                ((tabActiveKey === "global" || tabActiveKey === "client") || stringHelpers.isNullOrEmpty(editSiteId)) ? null : editSiteId,
                ((tabActiveKey === "global" || tabActiveKey === "site") || stringHelpers.isNullOrEmpty(formClientId)) ? null : formClientId,
                anprCameraId,
                roi,
                !stringHelpers.isNullOrEmpty(siteGroup) ? siteGroup : null,
                !stringHelpers.isNullOrEmpty(blueBadgeNumber) ? blueBadgeNumber : null,
                !stringHelpers.isNullOrEmpty(blueBadgeExpiryDate) ? blueBadgeExpiryDate : null,
                maxStayMinutes,
                noReturnWithinMinutes,
                props.organisationId,
                allowedVrmId,
                props.token
            );
        }
    };

    useEffect(() => {
        if (allowedVrm !== null) {
            const site = sites.find(x => x.id === allowedVrm.siteId)
            setVrm(allowedVrm.vrm);
            setVehicleMake(allowedVrm.vehicleMake);
            setVehicleModel(allowedVrm.vehicleModel);
            setColour(allowedVrm.vehicleColour);
            setReference(allowedVrm.reference);
            setSite(site);
            Api.getSiteGroupsBySiteId(
                props.organisationId, allowedVrm.siteId, 
                result => setSiteGroups(result),
                error => console.log(error),
                props.token
            )
            setFormClientId(allowedVrm.clientId)
            setSiteGroup(allowedVrm.siteGroupId);
            setAnprCameraId(allowedVrm.anprCameraId);
            setRoi(allowedVrm.roi);
            setDriverName(allowedVrm.driverName);
            setDriverMobileNumber(allowedVrm.driverMobileNumber);
            setBlueBadgeNumber(allowedVrm.blueBadgeNumber);
            setBlueBadgeExpiryDate(stringHelpers.isNullOrEmpty(allowedVrm.blueBadgeExpiryDate) ? "" : toInputFieldDateString(allowedVrm.blueBadgeExpiryDate));
            setStartDate(allowedVrm.startDate);
            setEndDate(allowedVrm.endDate);
            setReason(allowedVrm.notes);
            if (!stringHelpers.isNullOrEmpty(allowedVrm.enabledFromTime) && !stringHelpers.isNullOrEmpty(allowedVrm.enabledToTime)) {
                setValidOnlyAtSpecificTimes(true)
            } else {
                setValidOnlyAtSpecificTimes(false)
            }

            setValidOnlyOnSpecificDays(arrayUtilities.anyTrue([
                allowedVrm.monday,
                allowedVrm.tuesday,
                allowedVrm.wednesday,
                allowedVrm.thursday,
                allowedVrm.friday,
                allowedVrm.saturday,
                allowedVrm.sunday
            ]))
            setIsValidMonday(allowedVrm.monday)
            setIsValidTuesday(allowedVrm.tuesday)
            setIsValidWednesday(allowedVrm.wednesday)
            setIsValidThursday(allowedVrm.thursday)
            setIsValidFriday(allowedVrm.friday)
            setIsValidSaturday(allowedVrm.saturday)
            setIsValidSunday(allowedVrm.sunday)

            setMaxStayMinutes(allowedVrm.maxStayMinutes)
            setNoReturnWithinMinutes(allowedVrm.noReturnWithinMinutes)
            
            if (!stringHelpers.isNullOrEmpty(allowedVrm.enabledFromTime)) {
                setEnabledFromTime(allowedVrm.enabledFromTime);
            } else {
                setEnabledFromTime("00:00:00");
            }

            if (!stringHelpers.isNullOrEmpty(allowedVrm.enabledToTime)) {
                setEnabledToTime(allowedVrm.enabledToTime);
            } else {
                setEnabledToTime("23:59:00");
            }

            if (stringHelpers.isNullOrEmpty(allowedVrm.siteName) && stringHelpers.isNullOrEmpty(allowedVrm.clientName)) {
                setTabActiveKey("global")
            } else if (!stringHelpers.isNullOrEmpty(allowedVrm.clientName)) {
                setTabActiveKey("client")
            }
            else if (!stringHelpers.isNullOrEmpty(allowedVrm.siteName)) {
                setTabActiveKey("site")
            }
        }
        setErrorMessage("");
    }, [allowedVrm, isInEdit]);

    useEffect(() => {

        getSites(() => {
            if (allowedVrmId !== undefined) {
                getAllowedVrm();
                Api.getSiteGroupsBySiteId(
                    props.organisationId, allowedVrm.siteId, 
                    result => setSiteGroups(result),
                    error => console.log(error),
                    props.token
                )
            } else {
                setIsNew(true);
            }
        });
        getClients();
    }, []);

    useEffect(() => {
        if (site && site !== null) {
            setSiteName(site.name);

            Api.getSiteCameras((data) => {
                setAnprCameras(data);
            }, () => {
                setAnprCameras(null);
            }, props.organisationId, site.id, props.token);

            Api.getSiteGroupsBySiteId(
                props.organisationId, site.id, 
                result => setSiteGroups(result),
                error => console.log(error),
                props.token
            )
        } else {
            setSiteName("");
            setAnprCameras(null);
        }
    }, [site]);

    useEffect(() => {

        setCanSave(
            (
                !isClientOrClientManager ||
                (site && site !== null) ||
                (isClientOrClientManager && !stringHelpers.isNullOrEmpty(formClientId)) ||
                !stringHelpers.isNullOrEmpty(formClientId) ||
                (props.areDatesRequired && !stringHelpers.isNullOrEmpty(startDate))
            )
            && !stringHelpers.isNullOrEmpty(vrm)
            && isToDateAfterFromDate(startDate, endDate));
        if (site && site !== null) {
            Api.getSiteGroupsBySiteId(
                props.organisationId, site.id, 
                result => setSiteGroups(result),
                error => console.log(error),
                props.token
            )
        }
        if (isClientOrClientManager) {
            setAllowListUrl("/")
        } else {
            setAllowListUrl("/organisation/" + props.organisationId + "/allow-list")
        }
    }, [site, vrm, startDate, endDate, formClientId, isInEdit]);

    const handleTabChange = (e) => {
        setTabActiveKey(e);
        setSite(null);
        setAnprCameraId(null);
        setSiteGroup("");
        setRoi(null);

        if (e === "client" && isClientOrClientManager && clients.length === 1) {
            setFormClientId(clients[0].id);
        } else {
            setFormClientId("");
        }
    }

    const maxStayDisplay = minutesToUnit(maxStayMinutes)
    const noReturnDisplay = minutesToUnit(noReturnWithinMinutes)

    return (
        <>{!allowedVrm && !isNew && <Loader />}{!isNew && allowedVrm && allowedVrm !== null && <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card mb-3">
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h5 className="mb-0 d-flex align-items-center">Allowed VRM - <p className="small-number-plate ml-2 mb-0">{allowedVrm.vrm}</p></h5>
                                    </div>
                                    <Link className="btn btn-falcon-default btn-sm mr-3 py-1" type="button" to={allowListUrl}><i className="fas fa-reply"></i> Back</Link>
                                    {
                                        (
                                            roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) ||
                                            roleUtilities.isClientManager(props.user, props.organisationId) || 
                                            (
                                                roleUtilities.isClient(props.user, props.organisationId) &&
                                                !stringHelpers.isNullOrEmpty(allowedVrm.endDate) && isDateTimeElapsed(allowedVrm.endDate)
                                            )
                                        ) &&
                                        <button className="btn btn-falcon-default btn-sm dropdown-toggle py-2 mr-3 dropdown-caret-none" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i className="fas fa-ellipsis-h"></i></button>
                                    }
                                    <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-start">
                                        <button type="button" className="dropdown-item text-danger" data-toggle="modal" data-target="#deleteModal">
                                            <i className="fas fa-times"></i> Delete Allowed VRM</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card mb-3">
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h5 className="mb-0">Details</h5>
                                    </div>
                                    {!roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) && !roleUtilities.isThirdPartyManager(props.user, props.organisationId) && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && <div className="col-auto">
                                        <button type="button" className="btn btn-primary btn-sm ml-2" onClick={() => setIsInEdit(!isInEdit)}>
                                            <i className="fas fa-edit"></i> Edit</button>
                                    </div>}
                                </div>
                            </div>
                            {!isInEdit &&
                                <div className="card-body bg-light border-top details-container">
                                    <h6 className="mb-3 fs-1">Vehicle Details</h6>
                                    <div className="row">
                                        <div className="col-md-3 col-12  ">
                                            <p className="font-weight-semi-bold  mb-3 mt-1">VRM</p>
                                        </div>
                                        <div className="col-md-6 col-12 "><p className="small-number-plate mb-0">{allowedVrm.vrm}</p></div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3 ">Reference</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{allowedVrm.reference}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Vehicle Make</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{allowedVrm.vehicleMake}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3 ">Vehicle Model</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{allowedVrm.vehicleModel}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3 ">Colour</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{allowedVrm.vehicleColour}</div>
                                    </div>
                                    <hr className="border-dashed border-bottom-0"></hr>
                                    <h6 className="mb-3 fs-1">Driver Details</h6>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Name</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{allowedVrm.driverName}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Mobile Number</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{allowedVrm.driverMobileNumber}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Email Address</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{allowedVrm.driverEmailAddress}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Blue Badge Number</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{allowedVrm.blueBadgeNumber}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Blue Badge Expiry Date</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{toDateString(allowedVrm.blueBadgeExpiryDate)}</div>
                                    </div>
                                    <hr className="border-dashed border-bottom-0"></hr>
                                    <h6 className="mb-3 fs-1">Client/Site Details</h6>
                                    {!stringHelpers.isNullOrEmpty(allowedVrm.clientName) ? <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Client</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{allowedVrm.clientName}</div>
                                    </div>
                                    : <>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Site</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{allowedVrm.siteName && allowedVrm.siteName !== null && <>{allowedVrm.siteName}</>}{!allowedVrm.siteName && <>All</>}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Site Group</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{!stringHelpers.isNullOrEmpty(allowedVrm.siteGroupName) && allowedVrm.siteGroupName}</div>
                                        </div>
                                        {!stringHelpers.isNullOrEmpty(allowedVrm.anprCameraName) &&
                                            <div className="row">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold  mb-3">ANPR Camera</p>
                                                </div>
                                                <div className="col-md-6 col-12 ">{allowedVrm.anprCameraName}</div>
                                            </div>
                                        }                                    
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mb-3">Bay</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">{allowedVrm.roi}</div>
                                        </div>
                                    </>}
                                    <hr className="border-dashed border-bottom-0"></hr>
                                    <DisplayDateTime allowedVrm={allowedVrm} areDatesRequired={props.areDatesRequired} />
                                    <div className="row my-3">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold m-0">Valid only on specific days</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{validOnlyOnSpecificDays ? <>Yes</> : <>No</>}</div>
                                    </div>
                                    {
                                        validOnlyOnSpecificDays &&
                                        <div className="my-3">
                                            <div className="row mt-3">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold m-0">
                                                        Monday
                                                    </p>
                                                </div>
                                                <div className="col-md-6 col-12 ">
                                                    {isValidMonday ? <>Yes</> : <>No</>}
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold m-0">
                                                        Tuesday
                                                    </p>
                                                </div>
                                                <div className="col-md-6 col-12 ">
                                                    {isValidTuesday ? <>Yes</> : <>No</>}
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold m-0">
                                                        Wednesday
                                                    </p>
                                                </div>
                                                <div className="col-md-6 col-12 ">
                                                    {isValidWednesday ? <>Yes</> : <>No</>}
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold m-0">
                                                        Thursday
                                                    </p>
                                                </div>
                                                <div className="col-md-6 col-12 ">
                                                    {isValidThursday ? <>Yes</> : <>No</>}
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold m-0">
                                                        Friday
                                                    </p>
                                                </div>
                                                <div className="col-md-6 col-12 ">
                                                    {isValidFriday ? <>Yes</> : <>No</>}
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold m-0">
                                                        Saturday
                                                    </p>
                                                </div>
                                                <div className="col-md-6 col-12 ">
                                                    {isValidSaturday ? <>Yes</> : <>No</>}
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold m-0">
                                                        Sunday
                                                    </p>
                                                </div>
                                                <div className="col-md-6 col-12 ">
                                                    {isValidSunday ? <>Yes</> : <>No</>}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="row mb-3">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold m-0">Valid only at specific times of the day</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{validOnlyAtSpecificTimes ? <>Yes</> : <>No</>}</div>
                                    </div>
                                    {validOnlyAtSpecificTimes && 
                                    <div className="row mb-3">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold m-0">Time Range</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{enabledFromTime.slice(0, 5)} - {enabledToTime.slice(0, 5)}</div>
                                    </div>}
                                    <div className="row mb-3">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold m-0">Maximum stay</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">
                                            { maxStayDisplay.value } { maxStayDisplay.value !== null && Enums.TimeSpanMode[maxStayDisplay.unit] }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold m-0">No return within</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">
                                            { noReturnDisplay.value } { noReturnDisplay.value !== null  && Enums.TimeSpanMode[noReturnDisplay.unit] }
                                        </div>
                                    </div>
                                    <hr className="border-dashed border-bottom-0"></hr>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Notes</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{allowedVrm.notes}</div>
                                    </div>
                                </div>
                            }
                            {isInEdit &&
                                <>
                                    <div className="card-body bg-light border-top details-container">
                                        <h6 className="mb-3 fs-1">Vehicle Details</h6>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">VRM<span className="req"></span></p>
                                            </div>
                                            <div className="col-md-6 col-12 ">
                                                <div className='d-flex align-items-center'>
                                                    <div className="form-group mb-1">
                                                        <input disabled={loadingVehicleLookup} className="form-control mb-0 small-number-plate" type="text" value={vrm} onChange={(e) => setVrm(e.target.value.toUpperCase())} />
                                                    </div>
                                                    <button
                                                        onClick={ () => vehicleLookup() }
                                                        disabled={ 
                                                            stringHelpers.isNullOrEmpty(vrm) || 
                                                            !stringHelpers.isValidVrm(vrm) || 
                                                            (
                                                                !stringHelpers.isNullOrEmpty(vrm) && !stringHelpers.isNullOrEmpty(successfulLookupVrm) && vrm === successfulLookupVrm
                                                            ) ||
                                                            loadingVehicleLookup 
                                                        }
                                                        className='btn btn-falcon-default btn-sm ml-3 mb-1'
                                                    >
                                                        <div className='d-flex align-items-center'>
                                                            {
                                                                loadingVehicleLookup
                                                                    ? <span className="tiny-loader mr-2"><Loader /></span>
                                                                    : <i className='fas fa-search mr-1'></i>
                                                            }
                                                            Vehicle Lookup
                                                        </div>
                                                    </button>
                                                </div>
                                                {!stringHelpers.isNullOrEmpty(vrm) && !stringHelpers.isValidVrm(vrm) && <small className='text-danger'>Invalid VRM format</small>}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Reference</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">
                                                <div className="form-group mb-1">
                                                    <input className="form-control mb-0" type="text" value={reference} onChange={(e) => setReference(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Vehicle Make</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">
                                                <div className="form-group mb-1">
                                                    <input disabled={loadingVehicleLookup} className="form-control mb-0" type="text" value={vehicleMake} onChange={(e) => setVehicleMake(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Vehicle Model</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">
                                                <div className="form-group mb-1">
                                                    <input disabled={loadingVehicleLookup} className="form-control mb-0" type="text" value={vehicleModel} onChange={(e) => setVehicleModel(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Colour</p>
                                            </div>
                                            <div className="col-md-6 col-12 ">
                                                <div className="form-group mb-1">
                                                    <input disabled={loadingVehicleLookup} className="form-control mb-0" type="text" value={colour} onChange={(e) => setColour(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="border-dashed border-bottom-0"></hr>
                                        <h6 className="mb-3 fs-1">Driver Details</h6>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Name</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-1">
                                                    <input className="form-control mb-0" type="text" value={driverName} onChange={(e) => setDriverName(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Mobile Number</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-1">
                                                    <input className="form-control mb-0" type="text" value={driverMobileNumber} onChange={(e) => setDriverMobileNumber(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Email Address</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-1">
                                                    <input className="form-control mb-0" type="text" value={driverEmailAddress} onChange={(e) => setDriverEmailAddress(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Blue Badge Number</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-1">
                                                    <input className="form-control mb-0" type="text" value={blueBadgeNumber} onChange={(e) => setBlueBadgeNumber(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Blue Badge Expiry Date</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-1">
                                                    <input className="form-control mb-0" type="date" value={toInputFieldDateString(blueBadgeExpiryDate)} onChange={(e) => setBlueBadgeExpiryDate(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="border-dashed border-bottom-0"></hr>
                                        <ClientSiteTabbed 
                                            onTabChange={e => handleTabChange(e)} 
                                            clients={clients}
                                            client={formClientId}
                                            setClient={setFormClientId}
                                            sites={sites}
                                            site={site}
                                            setSite={setSite}
                                            siteGroup={siteGroup}
                                            siteGroups={siteGroups}
                                            setSiteGroup={setSiteGroup}
                                            anprCameras={anprCameras}
                                            anprCameraId={anprCameraId}
                                            setAnprCameraId={setAnprCameraId}
                                            roi={roi}
                                            setRoi={setRoi}
                                            activeKey={tabActiveKey}
                                            isClientOrClientManager={isClientOrClientManager}
                                            assignedSiteIds={clientAssignedSiteIds}
                                            assignedSiteGroupIds={clientAssignedSiteGroupIds}
                                        />                                        
                                        <hr className="border-dashed border-bottom-0"></hr>
                                        <AllowListDateTimeForm 
                                            startDate={startDate}
                                            endDate={endDate}
                                            setStartDate={setStartDate}
                                            setEndDate={setEndDate}
                                            validOnlyOnSpecificDays={validOnlyOnSpecificDays}
                                            setValidOnlyOnSpecificDays={setValidOnlyOnSpecificDays}
                                            validOnlyAtSpecificTimes={validOnlyAtSpecificTimes}
                                            setValidOnlyAtSpecificTimes={setValidOnlyAtSpecificTimes}
                                            enabledFromTime={enabledFromTime}
                                            setEnabledFromTime={setEnabledFromTime}
                                            enabledToTime={enabledToTime}
                                            setEnabledToTime={setEnabledToTime}
                                            isValidMonday={isValidMonday}
                                            setIsValidMonday={setIsValidMonday}
                                            isValidTuesday={isValidTuesday}
                                            setIsValidTuesday={setIsValidTuesday}
                                            isValidWednesday={isValidWednesday}
                                            setIsValidWednesday={setIsValidWednesday}
                                            isValidThursday={isValidThursday}
                                            setIsValidThursday={setIsValidThursday}
                                            isValidFriday={isValidFriday}
                                            setIsValidFriday={setIsValidFriday}
                                            isValidSaturday={isValidSaturday}
                                            setIsValidSaturday={setIsValidSaturday}
                                            isValidSunday={isValidSunday}
                                            setIsValidSunday={setIsValidSunday}
                                            areDatesRequired={props.areDatesRequired}
                                            maxStayMinutes={maxStayMinutes}
                                            setMaxStayMinutes={setMaxStayMinutes}
                                            noReturnWithinMinutes={noReturnWithinMinutes}
                                            setNoReturnWithinMinutes={setNoReturnWithinMinutes}
                                        />
                                        
                                        <hr className="border-dashed border-bottom-0"></hr>
                                        <div className="row">
                                            <div className="col-md-3 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">Notes</p>
                                            </div>
                                            <div className="col-md-6 col-12">
                                                <div className="form-group mb-1">
                                                    <textarea className="form-control mb-0" rows={4} value={reason} onChange={(e) => setReason(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer border-top ">
                                        <div className="row client-edit-buttons">
                                            <div className="col-12 col-sm-auto ml-auto  pl-0">
                                                <div id="dashboard-actions">
                                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => setIsInEdit(false)}>
                                                        <i className="fas fa-times"></i> Cancel</button>
                                                    <button type="button" className="btn btn-success btn-sm ml-2" disabled={!canSave} onClick={() => edit()}>
                                                        <i className="fas fa-check"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteModalLabel">Are you sure you want to delete this Allowed VRM?</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-danger btn-sm ml-2" data-dismiss="modal" onClick={() => Api.deleteAllowedVrm(() => history.push(allowListUrl), props.organisationId, allowedVrmId, props.token)}>
                                Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        </>}
            {isNew && <>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">Add New Allow VRM</h5>
                                        </div>

                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    <h6 className="mb-3 fs-1">Vehicle Details</h6>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">VRM<span className="req"></span></p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className='d-flex align-items-center'>
                                                <div className="form-group mb-1">
                                                    <input disabled={loadingVehicleLookup} className="form-control mb-0 small-number-plate" autoFocus={ true } type="text" value={ vrm } onChange={ (e) => setVrm(e.target.value.toUpperCase()) } />
                                                </div>
                                                <button
                                                    onClick={ () => vehicleLookup() }
                                                    disabled={ 
                                                        stringHelpers.isNullOrEmpty(vrm) || 
                                                        !stringHelpers.isValidVrm(vrm) || 
                                                        (
                                                            !stringHelpers.isNullOrEmpty(vrm) && !stringHelpers.isNullOrEmpty(successfulLookupVrm) && vrm === successfulLookupVrm
                                                        ) ||
                                                        loadingVehicleLookup 
                                                    }
                                                    className='btn btn-falcon-default btn-sm ml-3 mb-1'
                                                >
                                                    <div className='d-flex align-items-center'>
                                                        {
                                                            loadingVehicleLookup
                                                                ? <span className="tiny-loader mr-2"><Loader /></span>
                                                                : <i className='fas fa-search mr-1'></i>
                                                        }
                                                        Vehicle Lookup
                                                    </div>
                                                </button>
                                            </div>
                                            {!stringHelpers.isNullOrEmpty(vrm) && !stringHelpers.isValidVrm(vrm) && <small className='text-danger'>Invalid VRM format</small>}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Reference</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">
                                            <div className="form-group mb-1">
                                                <input className="form-control mb-0" type="text" value={reference} onChange={(e) => setReference(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Vehicle Make</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">
                                            <div className="form-group mb-1">
                                                <input disabled={loadingVehicleLookup} className="form-control mb-0" type="text" value={vehicleMake} onChange={(e) => setVehicleMake(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Vehicle Model</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">
                                            <div className="form-group mb-1">
                                                <input disabled={loadingVehicleLookup} className="form-control mb-0" type="text" value={vehicleModel} onChange={(e) => setVehicleModel(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Colour</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">
                                            <div className="form-group mb-1">
                                                <input disabled={loadingVehicleLookup} className="form-control mb-0" type="text" value={colour} onChange={(e) => setColour(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="border-dashed border-bottom-0"></hr>
                                    <h6 className="mb-3 fs-1">Driver Details</h6>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Name</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-0">
                                                <input className="form-control mb-1" type="text" value={driverName} onChange={(e) => setDriverName(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Mobile Number</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-0">
                                                <input className="form-control mb-1" type="text" value={driverMobileNumber} onChange={(e) => setDriverMobileNumber(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Email Address</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-1">
                                                <input className="form-control mb-0" type="text" value={driverEmailAddress} onChange={(e) => setDriverEmailAddress(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Blue Badge Number</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-1">
                                                <input className="form-control mb-0" type="text" value={ blueBadgeNumber } onChange={ (e) => setBlueBadgeNumber(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Blue Badge Expiry Date</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-1">
                                                <input className="form-control mb-0" type="date" value={ toInputFieldDateString(blueBadgeExpiryDate) } onChange={ (e) => setBlueBadgeExpiryDate(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="border-dashed border-bottom-0"></hr>                                    
                                    
                                    <ClientSiteTabbed 
                                        onTabChange={e => handleTabChange(e)} 
                                        clients={clients}
                                        client={formClientId}
                                        setClient={setFormClientId}
                                        sites={sites}
                                        site={site}
                                        setSite={setSite}
                                        siteGroup={siteGroup}
                                        siteGroups={siteGroups}
                                        setSiteGroup={setSiteGroup}
                                        anprCameras={anprCameras}
                                        anprCameraId={anprCameraId}
                                        setAnprCameraId={setAnprCameraId}
                                        roi={roi}
                                        setRoi={setRoi}
                                        activeKey={tabActiveKey}
                                        isClientOrClientManager={isClientOrClientManager}
                                        assignedSiteIds={clientAssignedSiteIds}
                                        assignedSiteGroupIds={clientAssignedSiteGroupIds}
                                    />
                                    <hr className="border-dashed border-bottom-0"></hr>
                                    <AllowListDateTimeForm 
                                        startDate={startDate}
                                        endDate={endDate}
                                        setStartDate={setStartDate}
                                        setEndDate={setEndDate}
                                        validOnlyOnSpecificDays={validOnlyOnSpecificDays}
                                        setValidOnlyOnSpecificDays={setValidOnlyOnSpecificDays}
                                        validOnlyAtSpecificTimes={validOnlyAtSpecificTimes}
                                        setValidOnlyAtSpecificTimes={setValidOnlyAtSpecificTimes}
                                        enabledFromTime={enabledFromTime}
                                        setEnabledFromTime={setEnabledFromTime}
                                        enabledToTime={enabledToTime}
                                        setEnabledToTime={setEnabledToTime}
                                        isValidMonday={isValidMonday}
                                        setIsValidMonday={setIsValidMonday}
                                        isValidTuesday={isValidTuesday}
                                        setIsValidTuesday={setIsValidTuesday}
                                        isValidWednesday={isValidWednesday}
                                        setIsValidWednesday={setIsValidWednesday}
                                        isValidThursday={isValidThursday}
                                        setIsValidThursday={setIsValidThursday}
                                        isValidFriday={isValidFriday}
                                        setIsValidFriday={setIsValidFriday}
                                        isValidSaturday={isValidSaturday}
                                        setIsValidSaturday={setIsValidSaturday}
                                        isValidSunday={isValidSunday}
                                        setIsValidSunday={setIsValidSunday}
                                        areDatesRequired={props.areDatesRequired}
                                        maxStayMinutes={maxStayMinutes}
                                        setMaxStayMinutes={setMaxStayMinutes}
                                        noReturnWithinMinutes={noReturnWithinMinutes}
                                        setNoReturnWithinMinutes={setNoReturnWithinMinutes}
                                    />
                                    <hr className="border-dashed border-bottom-0"></hr>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mt-1 mb-1">Notes</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-1">
                                                <textarea className="form-control mb-0" rows={4} value={reason} onChange={(e) => setReason(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer border-top ">
                                    <div className="row client-edit-buttons">
                                        <div className="col-12 col-sm-auto ml-auto pl-0">
                                            <div id="dashboard-actions">
                                                <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={() => history.push("/organisation/" + props.organisationId + "/allow-list")}>
                                                    <i className="fas fa-times"></i> Cancel</button>
                                                <button type="button" className="btn btn-success btn-sm ml-2" disabled={!canSave} onClick={() => submit()}>
                                                    <i className="fas fa-check"></i> Confirm</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>}
                {
                    !stringHelpers.isNullOrEmpty(errorMessage) &&
                    <ErrorModal
                        message={ errorMessage }
                        onHide={ () => setErrorMessage(null) }
                    />
                }
            </>
    )
}

export default AllowedVrm;